import { createContext } from 'react';
import { CreateLocalTrackOptions, LocalAudioTrack, LocalVideoTrack, Room } from 'twilio-video';
import { ErrorCallback } from '../twilio-meta';
import { Appointment, UserWithProfile } from '@uplift/api';

export interface IVideoContext {
  isLoading: boolean;
  room: Room | null;
  appointment?: Appointment;
  patient?: UserWithProfile;
  provider?: UserWithProfile;
  isRoomClosed: boolean;
  localTracks: (LocalAudioTrack | LocalVideoTrack)[];
  isConnecting: boolean;
  connect: (token: string) => Promise<void>;
  onError: ErrorCallback;
  getLocalVideoTrack: (newOptions?: CreateLocalTrackOptions) => Promise<LocalVideoTrack>;
  getLocalAudioTrack: (deviceId?: string) => Promise<LocalAudioTrack>;
  isAcquiringLocalTracks: boolean;
  removeLocalVideoTrack: () => void;
  removeLocalAudioTrack: () => void;
  getAudioAndVideoTracks: () => Promise<void>;
  isSharingScreen: boolean;
  toggleScreenShare: () => void;
  toggleVideoFilter: (reset?: boolean) => void;
  isVideoFilterEnabled: boolean;
  isVideoFilterSupported: boolean;
}

export const VideoContext = createContext<IVideoContext | null>(null);
